import { render, staticRenderFns } from "./userScore-drawer.vue?vue&type=template&id=181de966&"
import script from "./userScore-drawer.vue?vue&type=script&lang=js&"
export * from "./userScore-drawer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports